module.exports = __webpack_public_path__ + "static/img/slide-big1.c4bf2c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide-big1.jpg
// module id = 729
// module chunks = 1